<template>
  <b-container fluid id="members" class="page">
    <div
      class="title d-flex justify-content-between align-items-center flex-wrap"
    >
      <h1>Members</h1>
      <div>
        <label class="login-label" for="login-button"
          >Are you a team member?</label
        >
        <b-link href="/admin">
          <b-button id="login-button" variant="primary"> Login </b-button>
        </b-link>
      </div>
    </div>

    <div v-if="this.members.length !== 0">
      <div v-for="member_type in this.members" :key="member_type.index">
        <div v-if="member_type.length !== 0">
          <h2 v-if="member_type[0].type !== 'External Project Members'">
            {{ member_type[0].type }}
          </h2>
          <b-row v-if="member_type[0].type == 'MSc Students'">
            <b-col
              v-for="member in member_type"
              :key="member.id"
              cols="4"
              md="3"
              lg="2"
            >
              <memberbrief :member_data="member"></memberbrief>
            </b-col>
          </b-row>
          <b-row v-else-if="member_type[0].type == 'Alumni'">
            <b-col
              v-for="member in member_type"
              :key="member.id"
              cols="4"
              md="3"
              lg="2"
            >
              <memberbrief :member_data="member"></memberbrief>
            </b-col>
          </b-row>
          <b-row v-else-if="member_type[0].type !== 'External Project Members'">
            <b-col
              v-for="member in member_type"
              :key="member.id"
              cols="4"
              md="3"
              lg="2"
            >
              <member :member_data="member"></member>
            </b-col>
          </b-row>
        </div>
      </div>
    </div>
    <div v-else id="no-data" class="d-flex">
      <span><font-awesome icon="exclamation" fixed-width /></span>
      <p>No members have been added yet!</p>
    </div>
  </b-container>
</template>

<script>
import Member from "@/components/Member.vue";
import MemberBrief from "@/components/MemberBrief.vue";

export default {
  created() {
    let lookup = {};
    for (var member, i = 0; (member = this.page.get_members[i++]); ) {
      let type = member.type;

      if (!(type in lookup)) {
        lookup[type] = 1;
        this.types.push(type);
      }
    }

    for (let i = 0; i < this.types.length; i++) {
      this.members.push(
        this.page.get_members.filter(
          function (member) {
            return member.type == this.types[i] && member.breast === true;
          }.bind(this)
        )
      );
    }

    for (let i = 0; i < this.members.length; i++) {
      if (this.members[i].length === 0) {
        this.members.splice(i, 1);
      }
    }
  },
  name: "Members",
  data() {
    return {
      types: [],
      members: [],
    };
  },
  components: {
    member: Member,
    memberbrief: MemberBrief,
  },
  props: ["page"],
};
</script>

<style lang="scss">
#members {
  h2 {
    color: $secondary-color;
    margin: 1.2em 0 0.5em 0;
  }
}

.row {
  margin-right: -10px !important;
  margin-left: -10px !important;
  > div {
    padding-right: 10px !important;
    padding-left: 10px !important;
  }
}

.login-label {
  font-weight: 300 !important;
  color: $primary-color;
  margin-right: 1em;
}
</style>

<!--
  [class*="col-"]:nth-child(n + 7) {
    margin-top: 2em;
  }
  @include media-breakpoint-down(md) {
    [class*="col-"]:nth-child(n + 5) {
      margin-top: 2em;
    }
  }
  @include media-breakpoint-down(sm) {
    [class*="col-"]:nth-child(n + 4) {
      margin-top: 2em;
    }
  }
-->
